"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _carbonComponentsReact = require("carbon-components-react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\ndiv.tag-wrapper {\n  display: inline-block; }\n  div.tag-wrapper div.tag {\n    border: 1px solid;\n    background: white;\n    color: #e41b13;\n    margin: 0 5px 5px 0;\n    display: inline-block;\n    padding-top: 3px;\n    padding-bottom: 3px; }\n    div.tag-wrapper div.tag.secondary {\n      color: #fff;\n      background: #e41b13;\n      border-color: #e41b13; }\n    div.tag-wrapper div.tag.tertiary {\n      color: #000000; }\n    div.tag-wrapper div.tag.quaternary {\n      background: #4c4c4c;\n      color: #fff;\n      border-color: #4c4c4c; }\n    div.tag-wrapper div.tag.quinary {\n      background: #e8e8e8;\n      color: #000000;\n      border-color: #e8e8e8; }\n";
  const fileName = "Tag_Tag";
  const element = document.querySelector("style[data-sass-component='Tag_Tag']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Tag = props => {
  const classes = ['tag', props.type];
  return /*#__PURE__*/_react.default.createElement("div", {
    onClick: props.onClick ? props.onClick : null,
    className: "tag-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.Tag, {
    className: classes.join(' '),
    style: {
      cursor: props.onClick ? 'pointer' : 'default'
    }
  }, props.label));
};
Tag.propTypes = {
  label: _propTypes.default.string.isRequired,
  type: _propTypes.default.string,
  onClick: _propTypes.default.func
};
var _default = exports.default = Tag;